import { Axios } from "@/utils/axios";

export const getSangjoQuotations = async () => {
  const { data } = await Axios.get(`/sangjo_quotations/`);
  return data;
};
